// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  id: __t.u64().primaryKey(),
  conversationId: __t.u64().name("conversation_id"),
  fromUserId: __t.u64().name("from_user_id"),
  toUserId: __t.u64().name("to_user_id"),
  message: __t.string(),
  createdAt: __t.u64().name("created_at"),
  readAt: __t.option(__t.u64()).name("read_at"),
});
